const sortData = (data, field, direction) => {
  if (field === 'type') {
    data.sort((a, b) => {
      let aType;
      let bType;

      if (a.notification.category) {
        aType = a.notification.category;
      } else if (a.notification.strength) {
        aType = a.notification.strength;
      }

      if (b.notification.category) {
        bType = b.notification.category;
      } else if (b.notification.strength) {
        bType = b.notification.strength;
      }

      if (aType > bType) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aType < bType) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'age') {
    data.sort((a, b) => {
      if (a.notification.timestamp < b.notification.timestamp) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (b.notification.timestamp < a.notification.timestamp) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'corporationName') {
    data.sort((a, b) => {
      if (a.corporationName > b.corporationName) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.corporationName < b.corporationName) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'serviceTerritory') {
    data.sort((a, b) => {
      if (a.serviceTerritory > b.serviceTerritory) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.serviceTerritory < b.serviceTerritory) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'industry') {
    data.sort((a, b) => {
      if (a.industry > b.industry) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.industry < b.industry) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'account' || field === 'name' || field === 'lastName') {
    data.sort((a, b) => {
      let aLastName = a.lastName;
      let bLastName = b.lastName;
      if (a.customer) {
        aLastName = a.customer.lastName;
      }
      if (b.customer) {
        bLastName = b.customer.lastName;
      }
      if (a.corporation) {
        aLastName = a.corporation.lastName;
      }
      if (b.corporation) {
        bLastName = b.corporation.lastName;
      }
      if (!aLastName) {
        return 1;
      }

      if (!bLastName) {
        return -1;
      }

      if (aLastName > bLastName) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aLastName < bLastName) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'phone') {
    data.sort((a, b) => {
      if (!a.phone) {
        return 1;
      }
      if (!b.phone) {
        return -1;
      }
      if (a.phone > b.phone) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }
      if (a.phone < b.phone) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }
      return 0;
    });
  }

  if (field === 'date') {
    data.sort((a, b) => {
      let aTimestamp;
      let bTimestamp;

      if (a.notification.cycleStart) {
        aTimestamp = a.notification.cycleStart;
      } else if (a.notification.startTime) {
        aTimestamp = a.notification.startTime;
      }

      if (b.notification.cycleStart) {
        bTimestamp = b.notification.cycleStart;
      } else if (b.notification.startTime) {
        bTimestamp = b.notification.startTime;
      }

      if (aTimestamp > bTimestamp) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aTimestamp < bTimestamp) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'status') {
    data.sort((a, b) => {
      let aResolveStatus = 'Pending';
      let bResolveStatus = 'Pending';

      if (a.notification.resolveStatus === 'Archived') {
        aResolveStatus = 'Archived';
      } else if (a.notification.resolveStatus === 'Released') {
        aResolveStatus = 'Released';
      }

      if (b.notification.resolveStatus === 'Archived') {
        bResolveStatus = 'Archived';
      } else if (b.notification.resolveStatus === 'Released') {
        bResolveStatus = 'Released';
      }

      if (aResolveStatus > bResolveStatus) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aResolveStatus < bResolveStatus) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'uId') {
    data.sort((a, b) => {
      if (a.hub.uId > b.hub.uId) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.hub.uId < b.hub.uId) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'activatedDate') {
    data.sort((a, b) => {
      let aHub = a.hub;
      let bHub = b.hub;
      if (a.hubs) {
        const [hub] = a.hubs;
        aHub = hub;
      }
      if (b.hubs) {
        const [hub] = b.hubs;
        bHub = hub;
      }
      if (aHub.creationDate > bHub.creationDate) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aHub.creationDate < bHub.creationDate) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'address') {
    data.sort((a, b) => {
      let aAddress = a.zip;
      let bAddress = b.zip;
      if (a.customer) {
        aAddress = a.customer.serviceAddress[0].zip;
      }
      if (b.customer) {
        bAddress = b.customer.serviceAddress[0].zip;
      }
      if (!aAddress) {
        return 1;
      }
      if (!bAddress) {
        return -1;
      }

      if (aAddress > bAddress) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aAddress < bAddress) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'communication') {
    data.sort((a, b) => {
      const aMin = a.status.reduce((acc, st) => {
        let min = acc;
        if (st.ratio < min) {
          min = st.ratio;
        }
        return min;
      }, 1);
      const bMin = b.status.reduce((acc, st) => {
        let min = acc;
        if (st.ratio < min) {
          min = st.ratio;
        }
        return min;
      }, 1);

      if (aMin > bMin) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      if (bMin > aMin) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      return 0;
    });
  }

  if (field === 'percent' || field === 'strength') {
    data.sort((a, b) => {
      if (!a.ratio) {
        return 1;
      }

      if (!b.ratio) {
        return -1;
      }

      if (a.ratio > b.ratio) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.ratio < b.ratio) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'cLength') {
    data.sort((a, b) => {
      if (a.cycle.cycleTimeSeconds > b.cycle.cycleTimeSeconds) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (b.cycle.cycleTimeSeconds > a.cycle.cycleTimeSeconds) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'outside') {
    data.sort((a, b) => {
      if (a.cycle.tempAPI > b.cycle.tempAPI) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (b.cycle.tempAPI > a.cycle.tempAPI) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'deltaT') {
    data.sort((a, b) => {
      if (!a.cycle.deltaT) {
        return 1;
      }

      if (!b.cycle.deltaT) {
        return -1;
      }

      if (a.cycle.deltaT > b.cycle.deltaT) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.cycle.deltaT < b.cycle.deltaT) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'supply') {
    data.sort((a, b) => {
      if (!a.cycle.supplyAir) {
        return 1;
      }

      if (!b.cycle.supplyAir) {
        return -1;
      }

      let aSupply = a.cycle.supplyAir.minTemp;
      let bSupply = b.cycle.supplyAir.minTemp;

      if (a.cycle.acMode === 'Heat') {
        aSupply = a.cycle.supplyAir.maxTemp;
      }

      if (b.cycle.acMode === 'Heat') {
        bSupply = b.cycle.supplyAir.maxTemp;
      }

      if (aSupply > bSupply) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aSupply < bSupply) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'return') {
    data.sort((a, b) => {
      if (!a.cycle.returnAir) {
        return 1;
      }

      if (!b.cycle.returnAir) {
        return -1;
      }

      let aReturn = a.cycle.returnAir.minTemp;
      let bReturn = b.cycle.returnAir.minTemp;

      if (a.cycle.acMode === 'Heat') {
        aReturn = a.cycle.returnAir.maxTemp;
      }

      if (b.cycle.acMode === 'Heat') {
        bReturn = b.cycle.returnAir.maxTemp;
      }

      if (aReturn > bReturn) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aReturn < bReturn) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'air') {
    data.sort((a, b) => {
      if (!a.cycle.atticAir) {
        return 1;
      }

      if (!b.cycle.atticAir) {
        return -1;
      }

      if (a.cycle.atticAir.avgTemp > b.cycle.atticAir.avgTemp) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.cycle.atticAir.avgTemp < b.cycle.atticAir.avgTemp) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'oaTemp') {
    data.sort((a, b) => {
      if (!a.cycle.tempAPI) {
        return 1;
      }

      if (!b.cycle.tempAPI) {
        return -1;
      }

      if (a.cycle.tempAPI > b.cycle.tempAPI) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.cycle.tempAPI < b.cycle.tempAPI) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'orderDate') {
    data.sort((a, b) => {
      if (a.orderDate > b.orderDate) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.orderDate < b.orderDate) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'shipDate') {
    data.sort((a, b) => {
      if (!a.shipDate) {
        return 1;
      }
      if (!b.shipDate) {
        return -1;
      }

      if (a.shipDate > b.shipDate) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.shipDate < b.shipDate) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'email') {
    data.sort((a, b) => {
      let aEmail = a.email;
      let bEmail = b.email;
      if (a.customer) {
        aEmail = a.customer.email;
      }
      if (b.customer) {
        bEmail = b.customer.email;
      }
      if (!aEmail) {
        return 1;
      }
      if (!bEmail) {
        return -1;
      }

      if (aEmail > bEmail) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aEmail < bEmail) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'orderNumber') {
    data.sort((a, b) => {
      if (a.orderNumber > b.orderNumber) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.orderNumber < b.orderNumber) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'orderStatus') {
    data.sort((a, b) => {
      if (a.orderStatus > b.orderStatus) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.orderStatus < b.orderStatus) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'shippingAddress') {
    data.sort((a, b) => {
      if (a.shippingAddress.zip > b.shippingAddress.zip) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (b.shippingAddress.zip > a.shippingAddress.zip) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'tracking') {
    data.sort((a, b) => {
      if (!a.trackingNumber) {
        return 1;
      }

      if (!b.trackingNumber) {
        return -1;
      }

      const aTracking = JSON.parse(a.trackingNumber);
      const bTracking = JSON.parse(b.trackingNumber);

      if (aTracking[0].trackingnumber > bTracking[0].trackingnumber) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (aTracking[0].trackingnumber < bTracking[0].trackingnumber) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'zone') {
    data.sort((a, b) => {
      if (!a.hvac) {
        return 1;
      }

      if (!b.hvac) {
        return -1;
      }

      if (a.hvac.zone > b.hvac.zone) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.hvac.zone < b.hvac.zone) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'time') {
    data.sort((a, b) => {
      if (!a.cycle.startTime) {
        return 1;
      }

      if (!b.cycle.startTime) {
        return -1;
      }

      if (a.cycle.startTime > b.cycle.startTime) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.cycle.startTime < b.cycle.startTime) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'duration') {
    data.sort((a, b) => {
      if (!a.cycle.cycleTimeSeconds) {
        return 1;
      }

      if (!b.cycle.cycleTimeSeconds) {
        return -1;
      }

      if (a.cycle.cycleTimeSeconds > b.cycle.cycleTimeSeconds) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.cycle.cycleTimeSeconds < b.cycle.cycleTimeSeconds) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'mode') {
    data.sort((a, b) => {
      if (!a.cycle.acMode) {
        return 1;
      }

      if (!b.cycle.acMode) {
        return -1;
      }

      if (a.cycle.acMode > b.cycle.acMode) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.cycle.acMode < b.cycle.acMode) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'realCount') {
    data.sort((a, b) => {
      if (!a.countReal) {
        return 1;
      }

      if (!b.countReal) {
        return -1;
      }

      if (a.countReal > b.countReal) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.countReal < b.countReal) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  if (field === 'expectedCount') {
    data.sort((a, b) => {
      if (!a.countIdeal) {
        return 1;
      }

      if (!b.countIdeal) {
        return -1;
      }

      if (a.countIdeal > b.countIdeal) {
        if (direction === 'desc') {
          return -1;
        }
        return 1;
      }

      if (a.countIdeal < b.countIdeal) {
        if (direction === 'desc') {
          return 1;
        }
        return -1;
      }

      return 0;
    });
  }

  return data;
};

export default sortData;
